import { PublicDDQSession } from './BasicAuthHandler';

/**
 * Determines whether a third-party user's session grants access to the given client + third party + service.
 * A third-party user's email address may be associated with multiple services, and the "selected" service may change when the user clicks on the login link from an email.
 */
export const isSessionForService = (session: PublicDDQSession | undefined, client_id: string, third_party_id: string, service_id: string): boolean => session !== undefined && session.client_id === client_id && session.third_party_id === third_party_id && session.service_id === service_id;
